import { render, staticRenderFns } from "./StarOffOutline.vue?vue&type=template&id=54816782"
import script from "./StarOffOutline.vue?vue&type=script&lang=js"
export * from "./StarOffOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports